import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { nonLinearFormStore } from '../../store/NonLinear/NonLinearFormStore';
import SMPACHeader from '../Controls/SMPACHeader';
import { getQueryObject, sanitizeParameterValue } from '../../tools/toolkit';
import NonLinear from './NonLinear';
import '../../css/nonLinearForm.css';

let programmeId;
let formListPageNumber;
let headerAction;
class NonLinearForm extends React.Component {
    constructor(props) {
        super(props);
        document.title = 'Non-Linear';
        programmeId = this.props.programmeId || this.props.match.params['programmeId'];
        programmeId = sanitizeParameterValue(programmeId);
    }

    componentWillMount() {

        let parameter = getQueryObject(this.props.location.search);
        headerAction = parameter.action;
        formListPageNumber = parameter.progstatpage;

        headerAction = sanitizeParameterValue(headerAction);
        formListPageNumber = sanitizeParameterValue(formListPageNumber);

        if (programmeId) {
            this.props.getMode(programmeId);
        }
    }

    getHeaderStatus(editHeader, canEdit) {
        let status = canEdit ? 'edit' : 'view';

        if (canEdit && editHeader === 'editheader') {
            status = editHeader;
        }

        return status;
    }

    render() {
        if (!this.props.isLoading && this.props.visible) {
            return (
                <div className='nonLinearFormBody'>
                    <SMPACHeader programmeId={programmeId} action={this.getHeaderStatus(headerAction, this.props.canEdit)} formListPageNumber={formListPageNumber} />
                    <main id="mainContent">
                        <NonLinear programmeId={programmeId} canEdit={this.props.canEdit} visible={this.props.visible} headerAction={headerAction} broadcasterId={this.props.broadcasterId} />  
                    </main>
                </div>
            );
        }

        return '';
    }

}

export default connect(
    state => state.nonLinearForm,
    dispatch => bindActionCreators(nonLinearFormStore, dispatch)
)(NonLinearForm);



// WEBPACK FOOTER //
// ./src/components/NonLinear/NonLinearForm.js